// [controllers] Include custom controllers here.

import Cleaners from './controllers/Cleaners.js';
import Customers from './controllers/Customers.js';
import Admins from './controllers/Admins.js';
import Packages from './controllers/Packages.js';
import PromoCodes from './controllers/Promocodes.js';
import Checklists from './controllers/Checklists.js';
import Transactions from './controllers/Transactions.js';
import Jobs from './controllers/Jobs.js';
import CustomersCredits from './controllers/Customers-credits.js';
import CustomersAddresses from './controllers/Customers-addresses.js';
import Payment from './controllers/Payment.js';
import ContactRequests from './controllers/Contact-requests.js';
import Cms from './controllers/Cms.js';
import Testimonials from './controllers/Testimonials.js';
import ServiceOptions from './controllers/ServiceOptions.js';
import ScopeOfWorks from './controllers/ScopeOfWorks.js';
import Credits from './controllers/Credits.js';


// [init]

export default {
	
	modules: {


		// Create custom controller references here.

		cleaners: Cleaners,

		customers: Customers,

		admins: Admins,

		packages: Packages,

		promoCodes: PromoCodes,

		checklists: Checklists,

		transactions: Transactions,

		jobs: Jobs,

		customersCredits: CustomersCredits,

		customersAddresses: CustomersAddresses,

		payment: Payment,

		contactRequests: ContactRequests,

		cms: Cms,

		testimonials: Testimonials,

		serviceoptions: ServiceOptions,

		scopeofworks: ScopeOfWorks,

		credits: Credits
	}

};


// WEBPACK FOOTER //
// ./src/custom/_Controllers.js